import styled, { css } from "styled-components";

export const Wrapper = styled.div``;

export const Container = styled.div<{ isCentered?: boolean }>`
  border-bottom: 1px solid #b3b3b3;
  display: flex;
  align-items: center;
  gap: 30px;
  overflow-x: auto;
  height: 79px;
  justify-content: ${(props) => (props.isCentered ? "center" : "flex-start")};
`;

export const Tab = styled.div<{ active?: boolean }>`
  color: #000000;
  cursor: pointer;
  white-space: nowrap;
  padding: 22px 11px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.05em;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  @media (min-width: 1351px) and (max-width: 1920px) {
    font-size: 14px;
  }

  @media (min-width: 1025px) and (max-width: 1350px) {
    font-size: 12px;
  }

  @media (max-width: 1024px) {
    padding: 0px 10px;
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    font-size: 12px;
  }

  @media (min-width: 568px) and (max-width: 767px) {
    font-weight: 800;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: -0.05em;
    padding: 8px 18px;
  }

  @media (max-width: 567px) {
    font-weight: 800;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: -0.05em;
  }

  ${(props) => {
    if (props.active) {
      return css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-radius: 20px;
        border: solid 0.5px #653cd5;
        background-color: #fff;
        height: 40px;
        padding: 11px 22px;
        color: #653cd5;
        font-weight: 800;
        font-size: 16px;

        @media (min-width: 1351px) and (max-width: 1920px) {
          font-size: 14px;
          padding: 9px 18px;
          height: 34px;
        }

        @media (min-width: 1025px) and (max-width: 1350px) {
          font-size: 12px;
          padding: 10px 17px;
          height: 34px;
        }

        @media (min-width: 768px) and (max-width: 1024px) {
          font-size: 12px;
          padding: 10px 17px;
          height: 34px;
        }

        @media (min-width: 568px) and (max-width: 767px) {
          padding: 8px 18px;
          height: 38px;
        }

        @media (max-width: 567px) {
          padding: 11px 18px;
          height: 38px;
        }
      `;
    }
  }}

  &:hover {
    color: #653cd5;
  }
`;
